import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { getImgAltText } from 'utils/alt-attribute-helper';


class SliderHome extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            changedCarouselIndex: 0,
        };
    }

    renderArrowPrev(clickHandler)
    {
        return (<div className="carousel-arrow-container left tw-hidden md:tw-block"><button type="button" className="carousel-arrow" aria-label="Left Arrow" onClick={clickHandler}></button></div>);
    }

    renderArrowNext(clickHandler)
    {
        return (<div className="carousel-arrow-container right tw-hidden md:tw-block"><button type="button" className="carousel-arrow" aria-label="Right Arrow" onClick={clickHandler}></button></div>);
    }

    render()
    {
        return (
            <section className="tw-bg-gray-300 tw-w-full tw-h-screen">
                <div className="tw-relative tw-text-center tw-h-full">
                    <div className="">
                        <Carousel selectedItem={this.state.changedCarouselIndex} showThumbs={false} showArrows infiniteLoop showIndicators={false} showStatus={false} autoPlay interval={15000} renderArrowPrev={this.renderArrowPrev} renderArrowNext={this.renderArrowNext} preventMovementUntilSwipeScrollTolerance swipeScrollTolerance={20}>
                            <div className="auto-width">
                                <img className="tw-h-screen tw-object-cover tw-m-auto auto-width" src="https://d20kc7ig5255k8.cloudfront.net/assets/lux/sliderhome/sliderhome01.jpg" alt={getImgAltText('Taryn Levenstein')} />
                            </div>
                            <div className="auto-width">
                                <img loading="lazy" className="tw-h-screen tw-object-cover tw-m-auto auto-width" src="https://d20kc7ig5255k8.cloudfront.net/assets/lux/sliderhome/sliderhome02.jpg" alt={getImgAltText('Taryn Levenstein')} />
                            </div>

                            <div className="auto-width">
                                <img loading="lazy" className="tw-h-screen tw-object-cover tw-m-auto auto-width" src="https://d20kc7ig5255k8.cloudfront.net/assets/lux/sliderhome/sliderhome03.jpg" alt={getImgAltText('Taryn Levenstein')} />
                            </div>
                        </Carousel>
                    </div>
                </div>
            </section>
        );
    }
}

SliderHome.propTypes = {};

export default SliderHome;
